module.exports = __webpack_public_path__ + "static/media/icon_check-green.54cfcfa6.svg";